import Cookies from 'js-cookie';
import trackProductEvent from './ga4/trackProductEvents';

const handleSelectItemTracking = (cookieName: string) => {
  const selectItem = Cookies.get(cookieName);
  let parsedSelectItem;

  if (selectItem) {
    try {
      parsedSelectItem = JSON.parse(selectItem);
    } catch (e) {
      console.error(`Error parsing selectItem cookie`, e);
    }
  }

  if (parsedSelectItem) {
    trackProductEvent(parsedSelectItem);
    Cookies.remove(cookieName);
  }
};

export default handleSelectItemTracking;
